import React from 'react';
import theme from './SystemHealthPage.module.scss';

export interface StatProps {
    label: string;
    /** One value per minute, oldest first; nulls (no traffic) are skipped. */
    history?: (number | null)[] | null;
    format(value: number): string;
    isBad?(value: number): boolean;
}

export const Stat: React.FC<StatProps> = ({ label, history, format, isBad }) => {
    const values = (history ?? []).filter((v): v is number => v != null);
    const value = values.length ? values[values.length - 1] : null;
    const bad = value != null && (isBad?.(value) ?? false);
    return (
        <div className={`${theme.stat} ${bad ? theme.statBad : ''}`}>
            <div className={theme.statLabel}>{label}</div>
            <div className={`${theme.statValue} ${bad ? theme.danger : ''}`}>{value == null ? '—' : format(value)}</div>
            {values.length > 1 && <Sparkline values={values} />}
        </div>
    );
};

const SPARK_W = 160;
const SPARK_H = 28;

const Sparkline: React.FC<{ values: number[] }> = ({ values }) => {
    const min = Math.min(...values);
    const range = Math.max(...values) - min || 1;
    const points = values.map((v, i) => [
        (i / (values.length - 1)) * (SPARK_W - 4) + 2,
        SPARK_H - 3 - ((v - min) / range) * (SPARK_H - 6),
    ]);
    const line = points.map(([x, y], i) => `${i ? 'L' : 'M'}${x.toFixed(1)} ${y.toFixed(1)}`).join('');
    const [lastX, lastY] = points[points.length - 1];
    return (
        <svg className={theme.spark} viewBox={`0 0 ${SPARK_W} ${SPARK_H}`} preserveAspectRatio="none" aria-hidden>
            <path className={theme.sparkArea} d={`${line}L${SPARK_W - 2} ${SPARK_H}L2 ${SPARK_H}Z`} />
            <path className={theme.sparkLine} d={line} vectorEffect="non-scaling-stroke" />
            <circle className={theme.sparkDot} cx={lastX} cy={lastY} r={2.2} />
        </svg>
    );
};
